import React from 'react';
import styles from './TextGroupSectionC.module.sass';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import TextContainer from '../../reusable/title_description_group_container/TitleDescriptionGroupContainer';
import { TextGroupStyle } from '../../reusable/title_description_group/TitleDescriptionGroup';
import Christie from '../../assets/christie_photo_most.webp';
import MobileSpacer, { SpacerSize } from '../../reusable/mobile_spacer/MobileSpacer';
import Grid from '../../reusable/grid/Grid';
import RevealImage from '../../reusable/reveal/RevealImage';

const title = "Christie Greer."
const subtitle = "Lead Pediatric Occupational Therapist & Director of OT at Park Century School"
const paragraphs = [
  "Christie is a licensed pediatric occupational therapist with a passion for helping her clients grow, play, and thrive in their daily lives. Her goal when working with clients is to make her sessions engaging and fun while ensuring steady progress. She values a holistic approach and enjoys collaborating with parents, caregivers, and teachers to support the transfer of skills into everyday activities. She uses a personalized, client-centered approach to support children in improving their fine motor, sensory processing, executive functioning, and gross motor skills. She also loves finding unique activities to work on with each client, such as bike riding, knot tying, or cooking!",
  "Christie has been a practicing OT for nearly 10 years, with experience working in clinics, schools, and home-based settings. She joined Jennifer and the MOST team in 2018 after earning her Doctorate from The University of Southern California. She completed her doctoral residency at a non-profit school for students with special needs, where she focused the curriculum on strengthening functional skills such as self-care, social skills, and other fine motor tasks. As a devoted Trojan, Christie also received her Bachelor of Arts in Psychology/French and her Master of Arts in Occupational Therapy from USC.",
  "Christie holds a certification in Sensory Integration as well as special training in Handwriting Without Tears and Executive Functioning. When Christie is not working with children, she enjoys going to the beach, playing pickleball, and traveling with family and friends."
];

export default class TextGroupSectionC extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.dark}>
        <RevealImage className={styles.Christie} src={Christie} photo />
        <MobileSpacer size={SpacerSize.medium} />
        <Grid>
          <TextContainer 
            className={styles.TextContainer}
            dark={false} 
            title={title}
            subtitle={subtitle}
            paragraphs={paragraphs} 
            style={TextGroupStyle.small} />
        </Grid>
      </Section>
    )
  }

}